<template>
    <div class="py-4 container-fluid" v-if="questions">
        <div class="row" v-for="question in questions" :key="question.id">
            <div class="col-12 mb-5">
                <estadisticas :question="question"/>
            </div>
        </div>
    </div>
</template>
  
<script>
import Estadisticas from "./components/Estadisticas.vue";

export default {
    name: "encuestas",
    components: {
        Estadisticas
    },
    data() {
        return {
            questions: undefined
        };
    },
    created() {
        this.plain
            .get(`/questions`)
            .then((response) => {
                if (response.data.length !== 0) this.questions = response.data;
                else this.questions = [];
            })
            .catch((err) => {
                this.questions = [];
                console.log(err);
            });
    },
};
</script>
  